<arpio-center-panel>
  <h3 class="panel-title">Access denied</h3>
  <div class="margin-top">
    You don't have permission to access this resource. This may be because your account doesn't have the required
    permissions, or your authentication has expired. Please contact your account administrator if you believe this is an
    error.
  </div>
  <div class="margin-top actions">
    @if (hasHistory) {
      <button class="primary-button" (click)="goBack()">
        <svg lucideArrowLeft></svg>
        Go Back
      </button>
    }
    <button class="arpio-secondary-button" (click)="logout()">
      Log Out
      <svg lucideLogOut></svg>
    </button>
  </div>
</arpio-center-panel>
